export default "__VITE_ASSET__3$Gd7Iib__"